export const isProdEnv = () => process.env.VITE_ENV === 'production';

export const parseValue = (value: any) =>
  !value ? 0 : parseInt(value.toString()).toLocaleString();

export const parseDollars = (value: any) =>
  !value ? 0 : value.toLocaleString(undefined, { minimumFractionDigits: 2 });

export const parsePercentage = (value: any) => {
  if (!value) return 0;
  return value <= 1 ? (parseFloat(value) * 100).toFixed(2) : value.toFixed(2);
};
